import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const lang = localStorage.getItem('lang') || 'vi';
    const clonedRequest = req.clone({
      headers: req.headers.set('Accept-Language', lang)
    });
    return next.handle(clonedRequest);
  }
}



// WEBPACK FOOTER //
// /app/src/app/common/services/LanguageInterceptor.ts